import { useCallback, useContext, useMemo } from 'react';
import { PreviewDrawerContext } from '~/features/common';
import { FolderPermissionsDrawerContainer } from '../components';

export const useFolderPermissionsDrawer = (folderId: string) => {
  const { setIsOpen, setDrawerContent } = useContext(PreviewDrawerContext);

  const drawerContent = useMemo(() => <FolderPermissionsDrawerContainer folderId={folderId} />, [folderId]);

  return useCallback(() => {
    setIsOpen(true);
    setDrawerContent(drawerContent);
  }, [drawerContent, setDrawerContent, setIsOpen]);
};
